import {all, call, fork, put} from "redux-saga/effects";
import {apiClient} from 'util/Api'
import {
    ADD_TAG, UPDATE_TAG,
} from "constants/ActionTypes";

import {takeLeading} from "@redux-saga/core/effects";
import {bbStandardRequestHandler} from "../util/bbHelpers";
import {
    stopTagLoader,
} from "../actions";

/* ***************************
   Adding a Tag
   *************************** */

const postTagRequest = async (
        {
            definitionId,
            entityId,
            targetId,
            vectorId,
            testedVectorId,
            identityId,
            details,
            userId,
            customerId,
            subportfolioId
        }
    ) =>
    await  apiClient.post(`/risk/tag`,{
        definition: definitionId,
        entity: entityId ? entityId : null,
        target: targetId ? targetId : null,
        vector: vectorId ? vectorId : null,
        tested_vector: testedVectorId ? testedVectorId : null,
        tested_identity: identityId ? identityId : null,
        details: details ? details : null,
        user: userId ? userId : null,
        customer: customerId ? customerId : null,
        portfolio: subportfolioId ? subportfolioId : null,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* postTagGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addTag";     console.group(`${standardName} Generator...: `);
    const {
        definitionId,
        entityId,
        targetId,
        vectorId,
        testedVectorId,
        identityId,
        details,
        userId,
        customerId,
        subportfolioId,
        showUserMessage,
        affectedElementId,
        successAction = (data) => null,
        failAction = (data) => null
    } = payload;
    const request = yield call(postTagRequest,
        {
            definitionId,
            entityId,
            targetId,
            vectorId,
            testedVectorId,
            identityId,
            details,
            userId,
            customerId,
            subportfolioId
        },
    );
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, showUserMessage, true);

    //archiving generic way of calling ther reducer
    // if (didRequestSucceed) {
    //     yield put(addTagSuccess(
    //         {
    //             customerId: customerId,
    //             affectedElementId: affectedElementId,
    //             inboundData: request.data,
    //         }));
    // } else {
    //     yield put(addTagFail({
    //         affectedElementId: affectedElementId,
    //         request: request.data,
    //     }));
    // }

    if (didRequestSucceed) {
        yield put(successAction(
            {
                customerId: customerId,
                affectedElementId: affectedElementId,
                inboundData: request.data,
            }));
        yield put(stopTagLoader(

                affectedElementId,
                false
            ));
    } else {
        yield put(failAction({
            affectedElementId: affectedElementId,
            request: request.data,
        }));
        yield put(stopTagLoader(

                affectedElementId,
                true
            ));
    }

    console.groupEnd();
}

export function* watchLeadingPostTagGenerator() {
    yield takeLeading(ADD_TAG, postTagGenerator);
}

/* ***************************
   updateing a Tag
   *************************** */

const putTagRequest = async (tagId, newIsActive) =>
    await  apiClient.put(`/risk/tag`,{
            id: tagId,
            is_active: newIsActive,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* putTagGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "updateTag";     console.group(`${standardName} Generator...: `);
    const {
        successAction = (data) => null,
        failAction = (data) => null,
        tagId,
        newIsActive,
        customerId,
        showUserMessage = true,
        affectedElementId
    } = payload;
    const request = yield call(putTagRequest, tagId, newIsActive);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, showUserMessage, true);

    if (didRequestSucceed) {
        yield put(successAction(
            {
                customerId,
                affectedElementId,
                tagId: tagId,
                inboundData: request.data,
            }));
        yield put(stopTagLoader(

                tagId,
                false
            ));
    } else {
        yield put(failAction({
            customerId,
            affectedElementId,
            tagId: tagId,
            request: request.data,
        }));
        yield put(stopTagLoader(

                tagId,
                true
            ));
    }

    console.groupEnd();
}

export function* watchLeadingPutTagGenerator() {
    yield takeLeading(UPDATE_TAG, putTagGenerator);
}

/* ***************************
   root Saga
   *************************** */

export default function* rootSaga() {
    yield all([
        fork(watchLeadingPostTagGenerator),
        fork(watchLeadingPutTagGenerator),
    ]);
}